import { render, staticRenderFns } from "./DynamicNotification.vue?vue&type=template&id=2e2c2364"
import script from "./DynamicNotification.vue?vue&type=script&lang=js"
export * from "./DynamicNotification.vue?vue&type=script&lang=js"
import style0 from "./DynamicNotification.vue?vue&type=style&index=0&id=2e2c2364&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports